import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Tabs } from '../../../common/tabs'
import { formatVal } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { ALERT_TYPES } from './constant'
import classes from './index.module.scss'
import { selectAlertHighlight, selectLoading } from './store/slice'

export const AlertTabs = ({ alertType, setAlertType }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const alertHighlight = useSelector(selectAlertHighlight())
  const isLoading = useSelector(selectLoading('alertHighlight'))

  const negativeAlertsText = UseI18n('portfolio.summary.NEGATIVE_ALERT')
  const unreadAlertsText = UseI18n('portfolio.summary.UNREAD_ALERT')
  const totalAlertsText = UseI18n('portfolio.summary.TOTAL_ALERT')

  const options = [
    {
      label: `${negativeAlertsText}: ${formatVal(
        alertHighlight?.totalAlertNegative,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.NEGATIVE,
    },
    {
      label: `${unreadAlertsText}: ${formatVal(
        alertHighlight?.totalAlertUnread,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.UNREAD,
    },
    {
      label: `${totalAlertsText}: ${formatVal(
        alertHighlight?.totalAlert,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.TOTAL,
    },
  ]

  const alertRoute = COMPONENTS.alerts.components.alertList.route
  const linkTo =
    alertType === ALERT_TYPES.NEGATIVE
      ? `${alertRoute}?sentiment=negative`
      : alertType === ALERT_TYPES.UNREAD
      ? `${alertRoute}?readStatus=unread`
      : alertRoute

  if (isLoading || Object.values(alertHighlight).every((i) => !i)) return null

  return (
    <Element className={classes.alertTabs} style={{ borderColor: '#B5CEF8' }}>
      <Tabs
        items={options}
        activeKey={alertType}
        onChange={setAlertType}
        tabListClassName={classes.tabList}
        getAppendStyleItem={(active) => ({
          backgroundColor: active ? '#2C73E8' : '#F3F3F3',
          color: active ? '#FFFFFF' : '#191D25',
          fontSize: 12,
          padding: '2px 8px',
        })}
        styleContent={{ margin: 0 }}
        isI18n={false}
      />
      <Element style={{ color: '#2C73E8' }}>
        <Link to={linkTo} target="_blank">
          <Translate value="portfolio.summary.VIEW_ALL" />
        </Link>
      </Element>
    </Element>
  )
}
